<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/dashboard/admin/users' }"
        >人员管理</el-breadcrumb-item
      >
      <el-breadcrumb-item>人员详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel customer-info-panel mt-20">
      <div class="header customer-info-title flex-row-between">
        <span style="flex: 1">{{ user.name }}</span>
      </div>
      <div class="customer-detail">
        <dl style="min-width: 60px">
          <dt>手机号</dt>
          <dd>{{ user.phone_number }}</dd>
        </dl>
      </div>
      <el-button
        class="mt-10"
        type="primary"
        size="small"
        icon="el-icon-edit"
        plain
        @click="handleEdit"
        v-permission="Auth.userEdit"
        >编辑</el-button
      >
      <el-button
        class="mt-10"
        type="primary"
        size="small"
        icon="el-icon-refresh"
        plain
        @click="resetPassword"
        v-permission="Auth.userResetPwd"
        >重置密码</el-button
      >
    </div>
    <div class="panel mt-20">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="基本信息" name="tab1">
          <div>
            <!-- <div class="header">
              <h2>基本信息</h2>
            </div>-->
            <ul class="base-info">
              <li>
                <span class="title">姓名：</span>
                <span>{{ user.name }}</span>
              </li>
              <li>
                <span class="title">手机号：</span>
                <span>{{ user.phone_number }}</span>
              </li>
              <li>
                <span class="title">邮箱：</span>
                <span>{{ user.email }}</span>
              </li>
              <li>
                <span class="title">角色：</span>
                <span>{{ showRoles(user.auth_roles) }}</span>
              </li>
              <li v-if="auth.isPlatformUser()">
                <span class="title">区域：</span>
                <span>{{ AreaTextMap[user.area_id] }}</span>
              </li>
              <li v-if="auth.isPlatformUser()">
                <span class="title">城市：</span>
                <span>
                  {{ CodeToText[user.province]
                  }}{{ CodeToText[user.city] }}</span
                >
              </li>
              <!-- <li v-if="!auth.isPlatformUser()">
                <span class="title">销售组：</span>
                <span>{{ user.group.name }}</span>
              </li> -->
            </ul>
          </div>
        </el-tab-pane>
        <el-tab-pane label="角色/权限" name="tab2">
          <role-auth-tab :user="user"></role-auth-tab>
        </el-tab-pane>
        <el-tab-pane label="资源设置" name="tab3" v-if="!user.is_super_admin">
          <!-- <resource-tab
            :userID="userID"
            :userName="user.name"
            :areaID="user.area_id"
            :roles="user.auth_roles"
          ></resource-tab> -->
          <resource-tab-new
            :userID="userID"
            :userName="user.name"
            :userMark="user.mark"
            :areaID="user.area_id"
            :roles="user.auth_roles"
          ></resource-tab-new>
        </el-tab-pane>
      </el-tabs>
    </div>

    <user-former
      :model="model"
      :show.sync="dialogVisible"
      @updated="updatedCallback"
    ></user-former>
  </div>
</template>

<script>
import { userDetail } from '@/service/getData'
import { isMobile } from '@/util/index'
import { clone } from '@/util'
import auth from '@/util/auth'

import UserFormer from './former'
import RoleAuthTab from './role_auth'
import ResourceTab from './resource'
import ResourceTabNew from './resource_new'
import { AreaTextMap } from '@/config/global'
import { resetPassword } from '../../service/getData'
import { CodeToText } from '@/util/area_tool'

export default {
  components: {
    UserFormer,
    RoleAuthTab,
    ResourceTab,
    ResourceTabNew,
  },
  data() {
    return {
      AreaTextMap,
      CodeToText,
      auth,
      userID: parseInt(this.$route.params.id),
      user: {
        group: {},
      },
      activeTab: 'tab1',
      isMobile,
      dialogVisible: false,
      model: {},
    }
  },
  created() {
    this.activeTab = 'tab' + (this.$route.query.tab || 1)
    this.requestUser()
  },
  methods: {
    showRoles(roles) {
      if (!roles) return ''
      let names = roles.map((item) => {
        return item.name
      })
      return names.join(' / ')
    },
    async requestUser() {
      let res = await userDetail(this.userID)
      this.user = res.data
    },
    updatedCallback(data) {
      this.requestUser()
    },
    resetPassword() {
      this.$confirm('是否确认重置此用户密码？').then(() => {
        resetPassword(this.userID).then((res) => {
          if (res.code == 0) {
            this.$message.success('重置成功！')
          }
        })
      })
    },
    handleEdit() {
      let item = this.user
      let roles = item.auth_roles
        ? item.auth_roles.map((item) => {
            return item.id
          })
        : []
      this.dialogVisible = true
      this.$nextTick(() => {
        let area = []
        if (item.province) {
          area.push(item.province)
        }
        if (item.city) {
          area.push(item.city)
        }

        this.model = {
          id: item.id,
          name: item.name,
          roles: roles,
          phone_number: item.phone_number,
          group_id: item.group_id == 0 ? '' : item.group_id,
          area_id: item.area_id == 0 ? '' : item.area_id,
          area: area,
          departments: item.departments,
        }
      })
    },
  },
}
</script>

<style scoped>
.customer-info-panel {
  color: #6e6446;
  backg-color: #fcedbe;
}
.customer-info-title {
  font-size: 16px;
  margin-bottom: 10px;
  color: #3e3221;
}
.customer-detail dl {
  margin: 0;
}
.customer-detail {
  display: flex;
  justify-content: space-between;
}
.customer-detail dt {
  display: block;
  color: #adb5bd;
  line-height: 1.8;
  font-size: 12px;
}
.customer-detail dd {
  display: block;
  font-size: 14px;
  line-height: 1.3;
  margin: 0;
}

h4 {
  font-size: 14px;
  color: #3e3221;
}
.actions {
  padding-top: 10px;
  box-sizing: border-box;
}
.actions button {
  margin-right: 6px;
  margin-top: 10px;
}

.customer {
  backg-color: #fff;
  padding: 20px 12px;
}
.customer-name {
  font-size: 18px;
  color: #333;
  padding: 0;
  line-height: 20px;
}
.customer .title,
.device .title {
  display: flex;
  justify-content: space-between;
}

.info li {
  color: #666;
  font-size: 12px;
}
.device {
  margin-top: 12px;
  backg-color: #fff;
  padding: 20px 12px;
}
.info {
  font-weight: normal;
}
.filter {
  font-size: 12px;
  color: #777;
}
.filter label {
  margin: 0 4px;
}

.customer-data {
  display: flex;
  margin-top: 10px;
  border-top: 1px dotted #ddd;
  padding-top: 10px;
}
.customer-data li {
  width: 25%;
  text-align: left;
}
.customer-data li span {
  display: block;
  color: #0087cb;
}

.customer-data li span.title {
  color: #909399;
  line-height: 2;
}

.yuce li {
  color: #666;
  margin-bottom: 12px;
  padding-top: 12px;
  font-size: 12px;
  border-top: 1px dotted #ddd;
}

.yuce li:first-child {
  border-top: 0 none;
}

.text-tips {
  color: #999;
  font-size: 12px;
  margin: 0;
  margin-top: 10px;
}

.log-tag {
  margin-right: 4px;
}

.el-checkbox__label {
  font-size: 12px;
}

.overview .sub-info {
  border: 0 none;
}
.overview .sub-info-value {
  font-size: 20px;
  font-weight: 400;
}
.base-info {
  display: flex;
  flex-wrap: wrap;
}
.base-info li {
  width: 50%;
  padding-top: 10px;
}
.base-info .title {
  color: #999;
}
</style>

<style  scoped>
@media (max-width: 767px) {
  .customer-detail dl {
    margin: 0;
    display: flex;
    align-items: center;
    padding: 3px 0;
  }
  .customer-detail {
    flex-direction: column;
  }
  .customer-detail dt {
    color: #adb5bd;
    line-height: 1.8;
    font-size: 12px;
    margin-right: 10px;
  }
  .customer-detail dd {
    font-size: 12px;
    line-height: 1.3;
  }
}
</style>